'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class DSModel extends ngDepModel
{
	
	setupItemData(data){
		this.beforeSetup(data);
		for(let i of this._getParams()){
			if(typeof(data[i]) !== 'undefined'){
				this[i] = data[i];
			}
		}
		
		for(let f in this._getFields()){
			if(typeof(data.fields[f]) !== 'undefined'){
				this[this._getFields()[f]] = data.fields[f].value;
			}
		}
		this.afterSetup(data);
	}
	
	_getParams(){
		return [];
	}
	
	_getFields(){
		return {};
	}
	
	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'status':
				return this.getClassifValue(name, 'contract_status');
			case 'summary':
				return this.s('$filter')('nl2br')(this[name]);
			case 'consortium_agreement':
				return this.getClassifValue(name, 'yesno');
			case 'starting_date':
				if(this.starting_date_type == 1){
					return this.getClassifValue('starting_date_type', 'starting_date');
				}
				else if(this.starting_date_type == 2){
					return this.s('$filter')('u2date')(this.starting_date_date, 'dd/MM/y');
				}
			case 'end_date':
				if(this.end_date_type == 1){
					return this.getClassifValue('end_date_type', 'end_date');
				}
				if(this.end_date_type == 2){
					return this.end_date_date;
//					return this.s('$filter')('u2date')(this.end_date_date, 'dd/MM/y');
				}
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}